class DifferenceHoverCardsSlider extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.track = this.querySelector('[data-difference-hover-track]');
    this.slides = Array.from(this.querySelectorAll('[data-difference-hover-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-difference-hover-dot]'));
    this.raf = null;

    if (!this.track || this.slides.length < 2 || !this.dots.length) return;

    this.initialized = true;
    this.onScroll = this.queueUpdate.bind(this);
    this.onResize = this.queueUpdate.bind(this);

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.scrollToSlide(index));
    });

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    this.resetInitialPosition();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);

    if (this.raf) window.cancelAnimationFrame(this.raf);
  }

  scrollToSlide(index) {
    const left = this.getSlideLeft(index);

    this.track.scrollTo({ left, behavior: 'smooth' });
    this.setActiveDot(index);
  }

  resetInitialPosition() {
    this.track.scrollLeft = 0;
    this.setActiveDot(0);

    window.requestAnimationFrame(() => {
      this.track.scrollLeft = 0;
      this.setActiveDot(0);
    });
  }

  getSlideLeft(index) {
    const slide = this.slides[index];
    const firstSlide = this.slides[0];

    if (!slide || !firstSlide) return 0;

    return Math.max(0, slide.offsetLeft - firstSlide.offsetLeft);
  }

  queueUpdate() {
    if (this.raf) return;

    this.raf = window.requestAnimationFrame(() => {
      this.raf = null;
      this.updateActiveDot();
    });
  }

  updateActiveDot() {
    let activeIndex = 0;
    let closestDistance = Infinity;

    this.slides.forEach((slide, index) => {
      const distance = Math.abs(this.track.scrollLeft - this.getSlideLeft(index));

      if (distance < closestDistance) {
        closestDistance = distance;
        activeIndex = index;
      }
    });

    this.setActiveDot(activeIndex);
  }

  setActiveDot(activeIndex) {
    this.dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
}

if (!customElements.get('difference-hover-cards-slider')) {
  customElements.define('difference-hover-cards-slider', DifferenceHoverCardsSlider);
}
